module.exports = __webpack_public_path__ + "static/media/turokafteri_full2.70d6a6b2.jpg";